<template>
  <transition name="toast-fade">
    <div v-if="text" class="toast-common" role="status">
      <span class="toast-common__text">{{ text }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PaytypeToast',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.toast-common {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1005;
  max-width: calc(100vw - 48px);
  padding: 12px 20px;
  border-radius: 30px;
  background-color: #000;
  color: #fff;
  text-align: center;
  box-sizing: border-box;
  pointer-events: none;
}

.toast-common__text {
  display: block;
  font-size: 20px;
  line-height: 1.5;
  word-break: break-word;
}

.toast-fade-enter-active {
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
}

.toast-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.toast-fade-enter,
.toast-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, calc(-50% + 40px));
}
</style>
